import React, {useEffect, useState} from "react";
import {Route, useHistory} from "react-router-dom";
import {Header} from "../components/Header/index";
import ClientProfile from "../ClientManagement/ClientProfile/ClientProfile";
import NewClientProfile from "../ClientManagement/NewClientProfile/NewClientProfile";
import ProfileDetails from "../ClientManagement/ClientProfile/ProfileDetails/ProfileDetails";
import ProfileSettings, {ProfileSettingsType} from "../ClientManagement/ProfileSettings/ProfileSettings";
import PartnerWorkstation from "../ClientManagement/PartnerWorkstation/PartnerWorkstation";
import ClientRelationshipGroup from "../ClientManagement/ClientRelationshipGroup/ClientRelationshipGroup";
import PageUnavailable from "../components/ErrorPage/PageUnavailable";
import MeetingsHistory from "../ClientManagement/Meeting/MeetingsHistory";
import ViewArchivedProposalsAndProfiles
from "../ClientManagement/ClientProfile/ProfileDetails/ArchivedProposals/ViewArchivedProposalsAndProfiles";
import {RouteTracker} from "./RouteTracker";
import DashboardParent from "../ClientManagement/PartnerDashboard/DashboardParent";
import '../styles/pages/_index.scss';
import {Button} from "../components";
import {releaseToggleApiClient} from "../ReleaseToggles/ReleaseToggleApiClient";
import ClientRelationshipGroupInfo from "../ClientManagement/ClientRelationshipGroup/ClientRelationshipGroupInfo";
import DuplicateSuccessToast from "../ClientManagement/PartnerDashboard/DuplicateSuccessToast";

// Utility hook for feature flag
function useFeatureFlag(flagName: string, defaultValue = false) {
    const [flag, setFlag] = useState(defaultValue);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        setIsFetching(true);
        releaseToggleApiClient.getLaunchDarklyFlag(flagName)
            .then((response) => {
                setFlag(response);
                setIsFetching(false);
            })
            .catch((error) => {
                console.error(`Failed to retrieve ${flagName}`, error?.message);
                setIsFetching(false);
            });
    }, [flagName]);

    return [flag, isFetching] as const;
}

const RouteWithHeader: React.FC<{ path: string | string[], component: React.ReactNode }> = ({path, component}) => (
    <Route exact path={path}>
        <div>
            <Header/>
            {component}
        </div>
    </Route>
);

const RouteWithHeaderAndPacingNav: React.FC<{ path: string | string[], component: React.ReactNode }> = ({
    path,
    component
}) => {
    const [enablePacingModelBanner, isFetching] = useFeatureFlag("enablePacingModelBanner");
    const history = useHistory();

    if (isFetching) return null;

    if (!enablePacingModelBanner) {
        return (
            <Route exact path={path}>
                <div>
                    <Header/>
                    {component}
                </div>
            </Route>
        );
    }

  const handleLaunchPacingModel = () => {
      window.open("/pacingmodel/", "_blank");
  };

    return (
        <Route exact path={path}>
            <div>
                <Header/>
                <div className="custom-container-header">
                    <div className="container-header-bg"/>
                    <div className="container-header-content">
                        <div className="container-header-titles">
                            <h1 className="pacing-header-title">Alternative Investments</h1>
                            <h1 className="pacing-header-title pacing-header-bold">Pacing Model</h1>
                        </div>
                        <div className="container-header-titles-spacer"></div>
                        <div className="header-desc">
                            Model private investment commitments, forecast calls and distributions, generate dynamic visuals, and more!
                        </div>
                    </div>
                    <div className="header-row">
                        <Button
                            className="header-action-btn"
                            icon="right"
                            iconName="arrow_right"
                            aria-label="Launch Pacing Model"
                            onClick={handleLaunchPacingModel}
                        >
                            Launch Pacing Model
                        </Button>
                    </div>
                </div>
                {component}
            </div>
        </Route>
    );
};

export class Routes extends React.Component {
    render() {
        return (
            <div>
                <RouteWithHeaderAndPacingNav path={["/", "/Dashboard/:type"]} component={<DashboardParent/>}/>
                <RouteWithHeader path={"/Profile/:type/New"} component={<NewClientProfile/>}/>
                <RouteWithHeader path={"/Profile/:id"} component={<ProfileDetails/>}/>
                <RouteWithHeader path={"/PartnerWorkstation"} component={<PartnerWorkstation/>}/>
                <RouteWithHeader path={"/ClientRelationshipGroup"} component={<ClientRelationshipGroup/>}/>
                <RouteWithHeader path={"/ClientRelationshipGroup/Profile/:type/New/:crgid"} component={<ClientRelationshipGroupInfo/>}/>
                <Route path="/Profile/:id/ClientProfile" component={ClientProfile}/>
                <RouteWithHeader path={"/Profile/:profileId/ProfileSettings"} component={
                    <ProfileSettings settingsType={ProfileSettingsType.PROFILE}/>
                }/>
                <RouteWithHeader path={"/Profile/:profileId/NewProposalSettings"} component={
                    <ProfileSettings settingsType={ProfileSettingsType.NEW_PROPOSAL}/>
                }/>
                <RouteWithHeader path={"/Profile/:proposalId/ProposalSettings/:profileId"} component={
                    <ProfileSettings settingsType={ProfileSettingsType.PROPOSAL}/>
                }/>
                <RouteWithHeader path={"/Profile/:id/ViewArchivedProposals"} component={
                    <ViewArchivedProposalsAndProfiles/>
                }/>
                <RouteWithHeader path={"/Profile/:id/MeetingsHistory"} component={
                    <MeetingsHistory/>
                }/>
                <RouteWithHeader path={"/unavailable"} component={
                    <PageUnavailable/>
                }/>
                <DuplicateSuccessToast/>
            </div>
        );
    }
}

export default () => (
    <>
        <RouteTracker/>
        <Routes/>
    </>
);
